import React from "react";

const Events = () => <div>Events</div>;

export default Events;
